/**
 * Email helper — frontend side.
 *
 * All email sending is proxied through the backend API.
 * The SendGrid API key must NEVER be exposed to the browser.
 *
 * Backend endpoint: POST /api/v1/notifications/send-email
 * Expected body: { subject, to, content }
 */
import constants from '../constants'
import httpClient from '../services/httpClient'

const sendEmailEndpoint = `${constants.API_ROOT}/notifications/send-email`

export default function sendmail(subject, to, content) {
  return httpClient
    .post(sendEmailEndpoint, {
      subject,
      to: [].concat(to),
      content,
    })
    .then(res => res.data)
    .catch(err => {
      const body = err.response?.data
      throw new Error((body && body.message) || err.message || 'Failed to send email')
    })
}
